import { getView, requireAuth } from '@/lib/utils';
import { PageChemicalCreate } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/chemicals/create',
  component: getView('pages/PageChemicalEdit'),
  name: 'createNewChemical',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Chemicals > Create New',
    leftMenu: Left.ChemicalsList,
    roles: ['operator'],
    information: PageChemicalCreate,
    showBottomMenu: true,
  },
};
